<template>
  <div class="map-box">
    <span class="map-box-span" @click="back">返回</span>
    <iframe style="width: 100%;height: calc(100vh - 92px)" src="https://aoyunltd.com/jyb_map" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: "Map",
  methods: {
    back() {
      console.log(this.$router)
      this.$router.history.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.map-box {
  position: relative;

  .map-box-span {
    position: absolute;
    top: -8px;
    left: 0;
    background-color: #6584FF;
    width: 60px;
    font-weight: bold;
    color: #ffffff;
    padding: 6px 12px;
    border-radius: 8px;
  }

}
</style>
